// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__17btS","buttons":"Password_buttons__1Vpx3"};